import { createFileRoute } from '@tanstack/react-router'
import { HandoffChat } from '../../../../components/HandoffChat'

export const Route = createFileRoute('/desa/$slug/dashboard/percakapan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as { desaId: string }
    if (!desaId) return null
    return <HandoffChat desaId={desaId} />
  },
})
